import { computed, useTemplateRef } from 'vue'

export function useApmButtons() {
  const applePayButton = useTemplateRef<HTMLDivElement>('applePayButton')
  const googlePayButton = useTemplateRef<HTMLDivElement>('googlePayButton')

  const apmConfig = computed(() => ({
    applePay: {
      element: applePayButton.value,
      type: 'pay' as const,
    },
    googlePay: {
      element: googlePayButton.value,
      type: 'pay' as const,
    },
  }))

  return {
    applePayButton,
    googlePayButton,
    apmConfig,
  }
}
